import React, { forwardRef , useState , useEffect } from 'react';
import { Box , Divider } from "@mui/material";
import styled from 'styled-components';
const Clients = forwardRef((props, ref) => {
  // const clients = [
  //   { id: 1, name: 'Client 1', image: client1, description: 'Leading tech innovator in AI solutions.' },
  //   { id: 3, name: 'Client 3', image: client3, description: 'Pioneer in sustainable energy.' },
  //   { id: 4, name: 'Client 4', image: client4, description: 'Trusted healthcare provider.' },
  //   { id: 5, name: 'Client 5', image: client5, description: 'Innovative e-commerce platform.' },
  //   { id: 6, name: 'Client 6', image: client6, description: 'Cutting-edge logistics company.' },
  //   { id: 7, name: 'Client 7', image: client7, description: 'Premier education technology firm.' },
  //   { id: 8, name: 'Client 8', image: client8, description: 'Leader in cybersecurity solutions.' },
  //   { id: 9, name: 'Client 9', image: client9, description: 'Top retail chain innovator.' },
  //   { id: 10, name: 'Client 10', image: client10, description: 'Global manufacturing giant.' },
  //   { id: 11, name: 'Client 11', image: client11, description: 'Creative media production studio.' },
  //   { id: 12, name: 'Client 12', image: client12, description: 'Advanced robotics developer.' },
  //   { id: 13, name: 'Client 13', image: client13, description: 'Sustainable agriculture leader.' },
  //   { id: 14, name: 'Client 14', image: client14, description: 'Innovative fintech startup.' },
  //   { id: 15, name: 'Client 15', image: client15, description: 'Trusted insurance provider.' },
  //   { id: 16, name: 'Client 16', image: client16, description: 'Global telecommunications leader.' },
  //   { id: 17, name: 'Client 17', image: client17, description: 'Pioneer in cloud computing.' },
  //   { id: 18, name: 'Client 18', image: client18, description: 'Leader in entertainment streaming.' },
  //   { id: 19, name: 'Client 19', image: client19, description: 'Innovator in automotive tech.' },
  //   { id: 20, name: 'Client 20', image: client20, description: 'Global supply chain expert.' },
  //   { id: 21, name: 'Client 21', image: client21, description: 'Leader in renewable energy.' },
  //   { id: 22, name: 'Client 22', image: client22, description: 'Top software development firm.' },
  //   { id: 23, name: 'Client 23', image: client23, description: '' },
  //   { id: 24, name: 'Client 24', image: client24, description: '' },
  //   { id: 25, name: 'Client 25', image: client25, description: '' },
  //   { id: 26, name: 'Client 26', image: client26, description: '' },
  //   {id: 27 , name: 'Client 27', image: client27, description: ''},
  //   {id: 28 , name: 'Client 28', image: client28, description: ''},
  //   {id: 29 , name: 'Client 29', image: client29, description: ''},
  // ];

  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(
          'https://erp.awura.tech/api/method/frappe.client.get_list?doctype=Customer&fields=["name","image"]&limit_page_length=100',
          {
            headers: {
              Authorization: 'token f321af88e62a583:b7c938bb1356dbd',
            },
          }
        );
        const data = await response.json();
        if (data?.message?.length > 0) {
          const mapped = data.message.map((c, idx) => ({
            id: idx + 1,
            name: c.name,
            image: c.image ? `https://erp.awura.tech${c.image}` : null, 
          }));

          setClients(mapped);

          
        }
      } catch (err) {
        setClients([]);
      }
    };
    fetchClients();
  }, []);

  const SpacerBox = styled(Box)({
    height: { xs: '15px', sm: '20px', md: '30px' },
  });

  return (
    <>
      <ClientsSection ref={ref}>
        <MainTitle>Portfolio</MainTitle>
        <Subtitle>
          Partners and Customers
        </Subtitle>
        <Divider sx={{ my: 2, width: { xs: '231px', md: '312px' }, mx: 'auto', borderColor: '#17273F', borderBottomWidth: '3px' }} />
        <GridContainer>
          {clients.map((client) =>
            client.image ? (   // ✅ render only if image exists
              <ClientItem key={client.id}>
                <ClientRectangle>
                  <ClientImage src={client.image} alt={client.name} />
                </ClientRectangle>
              </ClientItem>
            ) : null
          )}
        </GridContainer>

      </ClientsSection>
      <SpacerBox />
    </>
  );
});

const ClientsSection = styled.section`
  text-align: center;
  padding-top: 40px;
  padding-right: 20px;
  padding-bottom: 160px;
  padding-left: 20px;

  @media (max-width: 768px) {
    padding: 20px 10px;
  }

  @media (max-width: 480px) {
    padding: 15px 5px;
  }

  @media (max-width: 320px) {
    padding: 10px 5px;
  }
`;

const MainTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 1.75rem;
    margin-bottom: 15px;
  }

  @media (max-width: 320px) {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
`;

const Subtitle = styled.h4`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    margin-bottom: 15px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
    margin-bottom: 10px;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(182px, 1fr));
  gap: 15px;
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    width: 95%;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fit, minmax(95px, 1fr));
    gap: 8px;
    padding: 10px 0;
  }

  @media (max-width: 320px) {
    grid-template-columns: repeat(auto-fit, minmax(95px, 1fr));
    gap: 6px;
    padding: 8px 0;
  }
`;

const ClientItem = styled.div`
  display: flex;
  justify-content: center;
`;

const ClientRectangle = styled.div`
  width: 180px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 140px;
    padding: 10px;
  }

  @media (max-width: 480px) {
    width: 120px;
    padding: 8px;
    border-radius: 10px;
  }

  @media (max-width: 320px) {
    width: 100px;
    padding: 6px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

const ClientImage = styled.img`
  width: 130px;
  height: 130px;
  object-fit: contain;
  margin: 10px 0;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 8px 0;
  }

  @media (max-width: 480px) {
    width: 80px;
    height: 80px;
    margin: 6px 0;
  }

  @media (max-width: 320px) {
    width: 60px;
    height: 60px;
    margin: 4px 0;
  }
`;

export default Clients;